import React, { useState} from "react";
import { Link , useLocation } from "react-router-dom";
import aryologo from "../images/aryologowhite.png";
import "../css/header.css";

function Header() {
  const [isActive, setIsActive] = useState(false);
  const location = useLocation();

  function openNav() {
    document.getElementById("myNav").style.width = "50%";
    document.body.style.overflow = "hidden";
    if (isActive) {
      closeNav();
    }
    setIsActive(!isActive);
  }

  function closeNav() {
    document.getElementById("myNav").style.width = "0%";
    document.body.style.overflow = "auto";
    setIsActive(false);
  }

  function goBottom() {
    closeNav();
    window.scrollTo({
      top: document.body.scrollHeight,
      behavior: "smooth",
    });
  }

 
  function goToProducts() {
    if (location.pathname.includes("become-a-dsa")){
      if (window.innerWidth < 768) {
        window.scrollTo({
          top: 1800,
          behavior: "smooth",
        });
      } else {
        window.scrollTo({
          top: 1700,
          behavior: "smooth",
        });
      }
    }
    else{
      if (window.innerWidth < 768) {
        window.scrollTo({
          top: 1800,
          behavior: "smooth",
        });
      } else {
        window.scrollTo({
          top: 1100,
          behavior: "smooth",
        });
      }
    }
   
    closeNav();
  }


  return (
    <div className={`header-wrapper ${isActive ? "active" : ""}`}>
      <div className="company_info">
        <div>
          <Link to="/" className="linkPath-logo">
            <img src={aryologo} alt="" />
          </Link>
        </div>

        <div>
          <span
            id="hamburger-menu"
            className={isActive ? "active" : ""}
            onClick={() => {
              openNav();
            }}
          >
            <p></p>
            <p></p>
            <p></p>
          </span>
        </div>
      </div>
      <div className="navbar-menu">
        <ul className="menu-1">
          <li>
            <div className="linkPath-menu" onClick={goToProducts}>
              Products
            </div>
          </li>
          <li>
            <Link to="/become-a-dsa" className="linkPath-menu" onClick={closeNav}>
              Become a DSA
            </Link>
          </li>
          <li>
            <a href="/blogs" className="linkPath-menu" onClick={closeNav} target="_blank">
              Blogs
            </a>
          </li>

          <li>
            <div className="linkPath-menu" onClick={goBottom}>
              Contact Us
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default Header;
